<template>
  <v-sheet width="300" height="600" color="transparent">
    <a
      :href="bannerAd.url"
      target="_blank"
      @click="
        onClick();
        $gtag.navigation('click_sponsor_link', bannerAd.url);
      "
    >
      <v-img :src="bannerAd.file"></v-img>
    </a>
  </v-sheet>
</template>
<script>
export default {
  props: {
    bannerAd: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  methods: {
    onClick() {
      this.$emit('clicked');
    },
  },
};
</script>
